var map = {
	"./2020.png": 2472,
	"./ACM1.png": 9235,
	"./ACM2.png": 4386,
	"./Ching.jpg": 4096,
	"./Chu Vn To.jpg": 5836,
	"./Griffith_University_logo.png": 3750,
	"./Gul Agha.jpg": 7360,
	"./HSIA.png": 7131,
	"./ICS_stacked-transparent.gif": 5454,
	"./IEEE_VN_Logo_Rect.jpg": 293,
	"./IEEE_logo.jpg": 1231,
	"./IKEEE.jpg": 7409,
	"./KHTN.png": 7383,
	"./Michela Taufer.jpg": 4004,
	"./NSF_4-Color_bitmap_Logo.png": 2151,
	"./Nalini Venkatasubramanian.jpg": 3930,
	"./Ono2010.jpg": 3530,
	"./STCLogo1.png": 9025,
	"./STC_CloudComputing.png": 2662,
	"./Tania Lorido Botran.jpg": 2851,
	"./Weisong Shi.jpg": 1903,
	"./campus-entrance-fall.jpg": 12,
	"./campus-entrance-fall.png": 709,
	"./clients-01.svg": 8314,
	"./clients-02.svg": 5170,
	"./clients-03.svg": 8076,
	"./clients-04.svg": 2750,
	"./clients-05.svg": 571,
	"./cloudbuslogo.png": 9171,
	"./cta-illustration.svg": 4161,
	"./dzungdao.jpg": 1603,
	"./feature-tile-icon-01.svg": 835,
	"./feature-tile-icon-02.svg": 5664,
	"./feature-tile-icon-03.svg": 7349,
	"./feature-tile-icon-04.svg": 4579,
	"./feature-tile-icon-05.svg": 792,
	"./feature-tile-icon-06.svg": 2634,
	"./features-split-icon.svg": 6691,
	"./features-split-image.svg": 9458,
	"./features-split-top-01.png": 6720,
	"./features-split-top-02.png": 1061,
	"./features-split-top-03.png": 1923,
	"./frame-icon.svg": 1660,
	"./header.JPG": 9821,
	"./hero-image.svg": 9970,
	"./hotel/Equatorial.jpg": 9015,
	"./hotel/Equatorial1.jpg": 3185,
	"./hotel/Equatorial2.webp": 5968,
	"./hotel/Equatorial3.jpg": 2159,
	"./hotel/Equatorial4.jpg": 5048,
	"./hotel/senviet.jpg": 4406,
	"./hotel/senviet1.webp": 8614,
	"./hotel/senviet2.webp": 4782,
	"./hotel/senviet3.webp": 8244,
	"./hotel/senviet4.webp": 1119,
	"./hotel/senviet5.webp": 8793,
	"./hotel/tanhoanglong.jpg": 9950,
	"./hotel/tanhoanglong1.webp": 2266,
	"./hotel/tanhoanglong2.webp": 5961,
	"./hotel/tanhoanglong3.webp": 1586,
	"./hotel/tanhoanglong4.webp": 419,
	"./huuduc.jpg": 2336,
	"./ieej-logo-b.jpg": 6277,
	"./illustration-element-01-top.svg": 8099,
	"./illustration-element-01.svg": 2389,
	"./illustration-element-02-top.svg": 9956,
	"./illustration-element-02.svg": 7980,
	"./illustration-element-03.svg": 7227,
	"./illustration-element-04.svg": 2141,
	"./illustration-element-05.svg": 1710,
	"./illustration-element-06.svg": 6349,
	"./illustration-element-07.svg": 5295,
	"./illustration-element-08.svg": 7555,
	"./illustration-section-01.svg": 3929,
	"./illustration-section-02.svg": 609,
	"./illustration-section-03.svg": 1126,
	"./illustration-section-04.svg": 3346,
	"./illustration-section-05.svg": 9866,
	"./illustration-section-06.svg": 9944,
	"./image-placeholder.png": 5992,
	"./img.png": 6041,
	"./kookmin.png": 7988,
	"./kunyu.jpg": 6610,
	"./logo.svg": 2835,
	"./member/Alan Sill.jpg": 3236,
	"./member/Alex Uta.jpg": 126,
	"./member/Auluck-Nitin.jpeg": 1883,
	"./member/Ben McCamish.jpg": 2799,
	"./member/Brian Larkins.jpg": 9035,
	"./member/David Chiu.jpg": 7954,
	"./member/Ganesh Neelakanta Iyer.jpg": 4231,
	"./member/Hohai University.png": 6835,
	"./member/Jianwu Wang.jpg": 2816,
	"./member/Josef Spillner.jpg": 1382,
	"./member/Kenneth Johnson.jpg": 2283,
	"./member/Luiz Bittencourt.jpg": 8139,
	"./member/Ngan Nguyen.jpg": 3481,
	"./member/North Texas.png": 9277,
	"./member/Pamela Delgado.jpg": 6993,
	"./member/Paolo Falcarin.jpg": 8658,
	"./member/Praveen Kumar Donta.png": 8074,
	"./member/Song Fu.jpg": 741,
	"./member/Texas Tech.png": 9928,
	"./member/Tommy Dang.jpg": 4054,
	"./member/U of Campinas.png": 5265,
	"./member/U of Puget Sound.png": 5568,
	"./member/UMBC.png": 2438,
	"./member/WSU.png": 8954,
	"./member/Xinghui Zhao.jpg": 2848,
	"./member/Yan Tang.jpg": 7347,
	"./member/Zichuan Xu.jpg": 6157,
	"./member/ahmed-200x301.png": 5972,
	"./member/unknown.jpg": 1438,
	"./news-image-01.jpg": 180,
	"./news-image-02.jpg": 4493,
	"./news-image-03.jpg": 1775,
	"./paymentQR.jpg": 8787,
	"./phamtrung.jpg": 7003,
	"./sikmin.jpg": 1624,
	"./tcsc-logo.gif": 1282,
	"./team-member-01.jpg": 3090,
	"./team-member-02.jpg": 2247,
	"./team-member-03.jpg": 2979,
	"./team-member-04.jpg": 2436,
	"./team-member-05.jpg": 2931,
	"./team-member-06.jpg": 5819,
	"./testimonial-image-01.jpg": 2642,
	"./testimonial-image-02.jpg": 4937,
	"./testimonial-image-03.jpg": 4719,
	"./tohoku-university-logo.png": 9204,
	"./uol_logo.jpg": 7508,
	"./venue/inside1.jpg": 778,
	"./venue/inside2.jpg": 4805,
	"./venue/outside1.jpg": 3056,
	"./venue/outside1.png": 8784,
	"./venue/outside2.jpg": 5624,
	"./venueHolder.png": 6228,
	"./video-placeholder.svg": 1904
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;